//

import React from "react";
import { PageBuilderStickyNavFragment } from "types/graphql-types";
import { graphql } from "gatsby";
import { isPresent } from "src/utils/checks";
import StickyMenu, { StickyMenuProps } from "components/StickyMenu/StickyMenu";

type PageBuilderStickyNavProps = PageBuilderStickyNavFragment;

const PageBuilderStickyNav: React.FC<
  React.PropsWithChildren<PageBuilderStickyNavProps>
> = ({ links }) => {
  const sectionRefs = computeSectionRefs(links);

  return (
    <StickyMenu
      sectionRefs={sectionRefs}
      translateDesktopTop={32}
      backgroundColor="white"
    />
  );
};

export const computeSectionRefs = (
  links: PageBuilderStickyNavFragment["links"]
): StickyMenuProps["sectionRefs"] => {
  return (links || [])
    .map((link) => {
      const target = link?.target;
      const title = link?.title?.localized;
      if (!title || !target) return null;

      const item: StickyMenuProps["sectionRefs"][0] = {
        id: target,
        title: title,
        trackingName: title
      };

      return item;
    })
    .filter(isPresent);
};

export default PageBuilderStickyNav;

// eslint-disable-next-line import/no-unused-modules
export const fragments = graphql`
  fragment PageBuilderStickyNav on SanityStickyNav {
    _key

    links {
      _key
      title {
        localized
      }
      target
    }
  }
`;
